import React from 'react';
import firebase from './Firebase';
import FormError from './FormError';
import { navigate } from '@reach/router';

class ForgotPassword extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            email: '', 
            errorMessage: null 
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    
    handleChange(e) {
        const itemName = e.target.name;
        const itemValue = e.target.value;

        this.setState({[itemName]: itemValue});

    }

    handleSubmit(e) {
        //prevent default behaviour
        e.preventDefault();

        // reset password
        firebase
        .auth()
        .sendPasswordResetEmail(this.state.email)
        .then(() => {
            alert('Password reset email sent!');
            alert('Please check your email!');
            navigate('/login');
        }
        )
        .catch(error => {
            if(error.message !== null) {
                this.setState({ errorMessage: error.message});
            } else {
                this.setState({ errorMessage: null});
            }
        }
        );
    }
    
    render(){

        return (
            <form className="mt-3" onSubmit={this.handleSubmit}>
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="card bg-light">
                        <div className="card-body">
                            <h3 className="font-weight-light mb-3">Reset Password</h3>
                            <section className="form-group">
                            { (this.state.errorMessage !== null) ? (
                                <FormError 
                                theMessage={this.state.errorMessage}
                                />
                            ) : null }
                            <label
                                className="form-control-label sr-only"
                                htmlFor="Email">
                                Email
                            </label>
                            <input
                                required
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={this.handleChange}

                            />
                            </section>
                            <div className="form-group text-right mb-0">
                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }
}
export default ForgotPassword;